module.exports = __webpack_public_path__ + "img/DSC_0796.a76dbf28.jpeg";